import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28 23V26.3333C28 26.7754 27.8244 27.1993 27.5118 27.5118C27.1993 27.8244 26.7754 28 26.3333 28H14.6667C14.2246 28 13.8007 27.8244 13.4882 27.5118C13.1756 27.1993 13 26.7754 13 26.3333V23",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.333 18.833L20.4997 22.9997L24.6663 18.833",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 23V13",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDownload;
